// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oulp","footer":"styles_footer__2p6VH","passCodeTooltip":"styles_passCodeTooltip__IBYeX"};